import { RootState } from '../../redux/store';
import { IModifierGroupSelection } from './ModifierGroupsState';

export const selectModifierGroupSelectionState = (state: RootState): IModifierGroupSelection =>
  state.menuBuilder.modifierGroups.modifierGroupSelection;
